<template>
  <v-container>
    <h1>EIE Assets</h1>
    <EieAssetsTable
      :assets="assets"
      :tranches="tranches"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { EieAssetsTable } from '@/components/eie';

export default {
  name: 'EIEAssets',
  components: {
    EieAssetsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.eieAssetsStore.loading,
      assets: state => state.eieAssetsStore.assets,
      tranches: state => state.eieAssetsStore.tranches,
    }),
  },
};
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/eie/EieAssetsView.vue